import styled from 'styled-components';

export const StyledMachineListPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 0;
  overflow: hidden;

  .machine-list-panel__title {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.SM};
    flex-shrink: 0;
  }

  .machine-list-panel__scroll-wrapper {
    position: relative;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      background: linear-gradient(to bottom, transparent, ${(props): string => props.theme.kcc.colors.WHITE});
      pointer-events: none;
      opacity: 1;
      transition: opacity 0.2s ease;
    }

    &.machine-list-panel__scroll-wrapper--at-bottom::after {
      opacity: 0;
    }
  }

  .machine-list-panel__scroll {
    height: 100%;
    overflow-y: auto;
    overflow-anchor: none;
  }

  .machine-list-panel__empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: ${(props): string => props.theme.kcc.spacing.BASE};
    gap: ${(props): string => props.theme.kcc.spacing.SM};
  }

  .machine-list-panel__empty-icon {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    color: ${(props): string => props.theme.kcc.colors.TEXT};

    svg {
      width: 64px;
      height: 64px;
    }
  }

  .machine-list-panel__empty-description {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.BASE}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.REGULAR};
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
    text-align: center;
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.SM};
  }

  .machine-list-panel__skeleton {
    display: flex;
    flex-direction: column;
    gap: ${(props): string => props.theme.kcc.spacing.SM};
    overflow: hidden;
  }

  .machine-list-panel__skeleton-item {
    border-bottom: 1px solid ${(props): string => props.theme.kcc.colors.GRAY_100};

    &:last-child {
      border-bottom: none;
    }

    .ant-skeleton-paragraph li + li {
      margin-block-start: ${(props): string => props.theme.kcc.spacing.XS} !important;
    }

    .ant-skeleton-title + .ant-skeleton-paragraph {
      margin-block-start: ${(props): string => props.theme.kcc.spacing.XS} !important;
    }
  }

  .machine-list-panel__loader {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    padding: ${(props): string => props.theme.kcc.spacing.XS} 0;
  }

  .machine-list-panel__item {
    padding: ${(props): string => props.theme.kcc.spacing.SM} ${(props): string => props.theme.kcc.spacing.XS}
      ${(props): string => props.theme.kcc.spacing.SM} 0;
    border-bottom: 2px solid ${(props): string => props.theme.kcc.colors.BORDER};

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .machine-list-panel__item-content {
    flex: 1;
    min-width: 0;
  }

  .machine-list-panel__item-name-row {
    display: flex;
    align-items: flex-start;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    margin-bottom: 2px;
  }

  .machine-list-panel__item-name {
    flex: 1;
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.SM}px`};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    margin: 0;
    padding-top: 3px;
  }

  .machine-list-panel__item-meta {
    display: flex;
    flex-direction: column;
  }

  .machine-list-panel__item-meta-text {
    margin-top: 3px;
  }

  .machine-list-panel__item-meta-row {
    font-size: ${(props): string => `${props.theme.kcc.typography.FONT_SIZE.SM}px`};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.BASE};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    display: flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.XXS};

    .svg-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;

      svg path {
        fill: ${(props): string => props.theme.kcc.colors.GRAY_500};
      }
    }
  }

  .machine-list-panel__item-arrow {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0;

    .svg-icon {
      display: block;
      width: 16px;
      height: 16px;
      color: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }
`;
